import jalaali from 'jalaali-js';

/**
 * تبدیل تاریخ میلادی به رشته شمسی مثل: 1403/5/12
 * جایگزین سبک moment-jalaali (فقط با jalaali-js)
 */
export function toJalaliDate(dateInput) {
  if (!dateInput) return '';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';
  const { jy, jm, jd } = jalaali.toJalaali(
    d.getFullYear(),
    d.getMonth() + 1,
    d.getDate()
  );
  return `${jy}/${jm}/${jd}`;
}

/** نمایش ساعت به وقت تهران مثل: 14:05 */
export function toTehranTime(dateInput) {
  if (!dateInput) return '';
  return new Date(dateInput).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Tehran',
  });
}
